import { LogLevel } from "angular-auth-oidc-client";

// PRODUCTION
export const environment = {
    production: true,
    identityConfig: {
        authority: 'https://identity.nside.io',
        redirectUrl: `https://rems-eop.nside.io/redirect`,
        postLogoutRedirectUri: 'https://v2.nside.io/Default.aspx',
        clientId: 'rems-eop.nside.io',
        scope: 'api.nside.io openid roles profile offline_access',
        responseType: 'code',
        silentRenew: true,
        silentRenewUrl: `https://rems-eop.nside.io/silent-renew`,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: LogLevel.Debug
    },
    apiBaseUrl: 'https://rems-eop-api.nside.io',
    nSideAssessUrl: 'https://v2.nside.io/Assess.aspx'
};